import { Injectable } from '@angular/core';
import { GuardResult, MaybeAsync, Router } from '@angular/router';
import { AuthenticationService } from '@flexyoo/auth';
import {
  EmployeePlanInvitationDataAccessService,
  EmployeeSettingsService,
} from '@flexyoo/employee/data-access';
import { map, switchMap } from 'rxjs';
import { getAppRoutePerRoleDefault } from '../../app-routes-per-role-defaults.constant';
import { RoleEnum } from '../../shared/models/general/general-enum';

@Injectable()
export class UserAccountGuard {
  constructor(
    protected router: Router,
    private readonly auth: AuthenticationService,
    private readonly employeeSettingsService: EmployeeSettingsService,
    private readonly employeePlanInvitationService: EmployeePlanInvitationDataAccessService
  ) {}

  canMatch(): MaybeAsync<GuardResult> {
    const user = this.auth.getCurrentUser();

    if (!user) {
      this.auth.logout();
      return false;
    }

    if (user.Role !== RoleEnum.Employee) {
      return true;
    }

    return this.employeeSettingsService.updateAndLoadEmployeeSettings(user.Id).pipe(
      switchMap(({ employeeSettings, tenantSettings }) =>
        this.employeePlanInvitationService.loadEmployeePlanInvitation(user.EmployeeId).pipe(
          map((invitation) => {
            void this.router.navigate([
              getAppRoutePerRoleDefault(
                RoleEnum.Employee,
                employeeSettings,
                tenantSettings,
                invitation
              ),
            ]);
            return false;
          })
        )
      )
    );
  }
}
